import React, { memo } from 'react';

import { PickupsTable } from './PickupsTable';

type Props = {
  startDate?: Date;
  endDate?: Date;
  isDeleting: boolean;
  venue?: string[];
  collectionPoint?: string[];
  onDelete: (ids: string[], onSuccess: () => void) => void;
};

export const AllPickups = memo<Props>((props) => {
  const { endDate, startDate, venue, collectionPoint } = props;

  return (
    <PickupsTable
      statusKey="all"
      endDate={endDate}
      startDate={startDate}
      venue={venue}
      collectionPoint={collectionPoint}
    />
  );
});
